import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuUtil } from "../utils/menu-utils";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  providers: [TranslatePipe]
})
export class AppMenuComponent implements OnInit, OnDestroy {

  model: any[] = [];
  skeletons = Array(100).fill(0);
  private menuIdSubscription: Subscription;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    MenuUtil.processMenu().subscribe({
      next: value => {
        this.model = value.flatMap(e => [e, {separator: true}]);
        MenuUtil.initializeActiveMenu();
        this.updateActiveStates();
      },
      complete: () => {
        this.skeletons = [];
      }
    });

    // Subscribe to menu ID changes to update active states
    this.menuIdSubscription = MenuUtil._menuIdSubject$.asObservable().subscribe({
      next: value => {
        if (value?.id) {
          this.updateActiveStates();
        }
      }
    });
  }

  private updateActiveStates() {
    const currentId = MenuUtil._menuIdSubject$.getValue()?.id;
    if (currentId && this.model.length > 0) {
      // Filter out separators, update active states, then re-add separators
      const menuItems = this.model.filter(item => !item.separator);
      const updatedItems = MenuUtil.updateMenuActiveState(menuItems, currentId);
      this.model = updatedItems.flatMap(e => [e, {separator: true}]);
      this.cd.detectChanges();
    }
  }

  ngOnDestroy() {
    if (this.menuIdSubscription) {
      this.menuIdSubscription.unsubscribe();
    }
  }
}
